module.exports = __webpack_public_path__ + "img/facts.22f53b54.png";